import { render } from "./GoldCircleButton.vue?vue&type=template&id=321bbab2&scoped=true"
import script from "./GoldCircleButton.vue?vue&type=script&lang=js"
export * from "./GoldCircleButton.vue?vue&type=script&lang=js"

import "./GoldCircleButton.vue?vue&type=style&index=0&id=321bbab2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321bbab2"]])

export default __exports__